import "../styles/_app.scss";
import React from "react"; 
import { Component } from "react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom"; 
import AppContext from "./appContext";
import loadable from "@loadable/component";  
import history from "history.js";


import routes from "./RootRoutes";
import { Store } from "./redux/Store"; 

const EgretLayout = loadable(() => import("./EgretLayout/EgretLayout" /* webpackChunkName: "EgretLayout_App" */)); 
const EgretTheme = loadable(() => import("./EgretLayout/EgretTheme/EgretTheme" /* webpackChunkName: "EgretTheme_App" */));  


class App extends Component {


    render() {


        return (
            <React.Fragment>
                <AppContext.Provider value={{ routes }}>
                    <Provider store={Store}>
                        <EgretTheme>
                            <Router history={history}>
                                <EgretLayout />
                            </Router>
                        </EgretTheme>
                    </Provider>
                </AppContext.Provider>
            </React.Fragment>



        );
    };
};

export default App;
